module.exports = __webpack_public_path__ + "static/img/10.a2e580a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/11.18/10.png
// module id = yXmc
// module chunks = 1